export default __webpack_public_path__ + "static/media/intesa-s-paolo.4c0b6875.png";